export default function BusinessWelcome({ contentData, initError, initLoader }) {
  return <div>This is Business Welcome page</div>;
}
